<template>
    <nav class="navbar">
        <div class="navbar-space" @click="ToggleNavbar"></div>
        <div class="navbar-menu">
            <div class="flex flex-row items-center justify-around py-3 w-full cursor-pointer sticky top-0 background" @click="ToggleNavbar">
                <p class="title-sm select-none"><b class="text-gradient select-none">Меню</b></p>
                <button class="ml-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                    </svg>
                </button>
            </div>
            <div class="navbar-menu-item" @click="GoTo('Home')">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
                    </svg>
                </p>
                <p>Тикеты</p>
            </div>
            <div class="navbar-menu-item" @click="GoTo('Control')" v-if="$root.HasRole(this.$store.state.mainOperatorRole) || $root.HasRole(this.$store.state.adminRole)">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                    </svg>
                </p>
                <p class="text-sm">Контроль операторов</p>
            </div>
            <div class="navbar-menu-item" @click="GoTo('Themes')" v-if="$root.HasRole(this.$store.state.mainOperatorRole) || $root.HasRole(this.$store.state.adminRole)">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6z" />
                    </svg>
                </p>
                <p>Темы</p>
            </div>
            <div class="navbar-menu-item" @click="Logout">
                <p class="font-bold mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                </p>
                <p>Выход</p>
            </div>
        </div>
        <div class="flex flex-row items-center justify-between">
            <button class="" @click="ToggleNavbar">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />
                </svg>
            </button>
            <p class="title-sm ml-2 select-none">Samgk <b class="text-gradient select-none">Служба заботы</b></p>
        </div>
        <div class="flex flex-row items-center justify-between">
            <button class="mr-2" @click="$root.ToggleDarkMode">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-indigo-800" viewBox="0 0 20 20" fill="currentColor" v-if="$store.state.mode === 'dark'">
                    <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor" v-else-if="$store.state.mode === 'light'">
                    <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" />
                </svg>
            </button>
            <p class="font-bold">{{login}}</p>
        </div>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            login: ""
        }
    },
    methods: {
        ReportBug(e) {
            e.preventDefault()
        },
        Logout() {
            this.$router.push({name: 'Logout'})
        },
        GoTo(name) {
            this.$router.push({name: name})
        },
        ToggleNavbar() {
            let navbar = document.querySelector("nav.navbar")
            let menu = navbar.querySelector(".navbar-menu")
            let space = navbar.querySelector(".navbar-space")
            if (this.show) {
                menu.classList.add("hide")
                space.classList.remove("show")
                setTimeout(()=>{
                    menu.classList.remove("show")
                    menu.classList.remove("hide")
                }, 400)
            } else {
                menu.classList.add("show")
                space.classList.add("show")
            }
            this.show = !this.show
        },
        GetLogin() {
            fetch(this.$store.state.apiAddr + "/v1.0/users/me/info", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
                
            })
            .then(response =>{return response.json()})
            .then(res => {
                if (this.$root.HandleFetchError(res)) return

                if (res["data"]["user"]["login"] !== undefined || res["data"]["user"]["login"] !== null) {
                    this.login = res["data"]["user"]["login"]
                }
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
    },
    created() {
        if (this.$root.GetToken() != null) {
            this.GetLogin()
        }
    }
}
</script>